import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, Badge } from "reactstrap"
import GeneralTables from "components/Common/GeneralTable"
import { getProviderTransfers } from "store/provider-transfer/provider-transfer-action"

const ProviderTransferList = () => {
  document.title = "My Transfer Requests"

  const dispatch = useDispatch()
  const { data, loading } = useSelector(state => state.providerTransfer)
  const [pageNumber, setPageNumber] = useState(10)

  useEffect(() => {
    dispatch(getProviderTransfers(null, pageNumber))
  }, [pageNumber])

  const onPageClick = link => {
    dispatch(getProviderTransfers(link.url, pageNumber))
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const statusBadge = status => {
    switch (status) {
      case "Pending":
        return <Badge color="warning">Pending</Badge>
      case "Approved":
        return <Badge color="success">Approved</Badge>
      case "Accepted":
        return <Badge color="success">Accepted</Badge>
      case "Rejected":
        return <Badge color="danger">Rejected</Badge>
      default:
        return <Badge color="secondary">{status}</Badge>
    }
  }

  const typeBadge = type => {
    if (type === "incoming") {
      return <Badge color="info">Incoming</Badge>
    }
    if (type === "incoming_return") {
      return <Badge color="warning">Incoming Re-allocation </Badge>
    }
    return <Badge color="primary"> Re-allocation</Badge>
  }

  return (
    <div className="page-content">
      <Breadcrumbs title="Provider" breadcrumbItem="Transfer History" />
      <Card>
        <CardBody>
          <GeneralTables
            data={data?.data}
            loading={loading}
            parentCheckbox={false}
            headers={[
              "SN",
              "Type",
              "Item",
              "Batch",
              "From Provider",
              "Total Qty",
              "Used Qty",
              "Available Qty",
              "Transfer Qty",
              "Status",
              "Admin Note",
              "Date",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(transfer, index) => (
              <tr key={transfer.id}>
                <th scope="row">{data?.meta?.from + index}</th>
                <td>{typeBadge(transfer.transfer_type)}</td>
                <td>
                  {transfer?.provider_in?.item?.ip_item_description ||
                    transfer?.provider_in?.item?.unfp_item_name ||
                    transfer?.provider_in?.item_name ||
                    "-"}
                </td>
                <td>{transfer?.provider_in?.batch_number || "-"}</td>
                <td>{transfer.from_provider || "-"}</td>
                <td>{transfer.total_receipt_qty}</td>
                <td>{transfer.used_qty}</td>
                <td>{transfer.available_qty}</td>
                <td>
                  <strong>{transfer.transfer_qty}</strong>
                </td>
                <td>{statusBadge(transfer.status)}</td>
                <td>{transfer.admin_note || "-"}</td>
                <td>{new Date(transfer.created_at).toLocaleDateString()}</td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default ProviderTransferList
